import ErrorBoundary from 'helpers/errorBoundary';

class PMUErrorBoundary extends ErrorBoundary {

}

export default PMUErrorBoundary;
